import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import DeleteModal from "../../components/DeleteModal";
import "../../styles/components/forms.css";
import "../../styles/components/ActivitySelector.css";
import ActivitySelector from "../../components/common/ActivitySelector";
import EditProgramModal from "../../components/editProgramModal";

export default function NewProgram() {
  const [programName, setProgramName] = useState("");
  const [programDescription, setProgramDescription] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [programImage, setProgramImage] = useState(null);
  const [editDescription, setEditDescription] = useState("");
  const [editImage, setEditImage] = useState(null);
  const [programs, setPrograms] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState("");
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [weeks, setWeeks] = useState([]);
  const [activities, setActivities] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedWeeks, setExpandedWeeks] = useState([]);
  const [levels, setLevels] = useState([]);
  const [programLevelId, setProgramLevelId] = useState("");
  const [editLevelId, setEditLevelId] = useState("");
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [expandedProgramWeeks, setExpandedProgramWeeks] = useState({});
  const [expandedProgramDays, setExpandedProgramDays] = useState({});
  const [isFree, setIsFree] = useState(false);
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    fetchInitialData();
    fetchActivities();
  }, []);

  const fetchInitialData = async () => {
    try {
      const [programsResponse, levelsResponse] = await Promise.all([
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/programs`, {
          withCredentials: true,
        }),
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/levels`, {
          withCredentials: true,
        }),
      ]);
      setPrograms(programsResponse.data.result);
      setLevels(levelsResponse.data);
    } catch (error) {
      console.error("Error fetching initial data:", error);
      setError("Error fetching initial data");
    }
  };

  const fetchPrograms = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/programs`,
        {
          withCredentials: true,
        }
      );
      setPrograms(response.data);
    } catch (error) {
      console.error("Error fetching programs:", error);
      setError("Error fetching programs");
    }
  };

  const fetchActivities = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/activities`,
        {
          withCredentials: true,
        }
      );
      console.log(response.data, "FETHCING ACTIVITIES");
      setActivities(response.data);
    } catch (error) {
      console.error("Error fetching activities:", error);
      setError("Failed to fetch activities: " + error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!programName.trim()) return;

    try {
      const formData = new FormData();
      formData.append("name", programName);
      formData.append("description", programDescription);
      formData.append("short_description", shortDescription);
      formData.append("levelId", programLevelId);
      formData.append("isFree", isFree ? 1 : 0);
      formData.append("isPublished", isPublished ? 1 : 0);

      // Process weeks data to match the structure expected by the backend
      const processedWeeks = {};
      weeks.forEach((week, weekIndex) => {
        const weekName = `Week ${week.weekNumber}`;
        processedWeeks[weekName] = {
          name: weekName,
          description: week.description || "",
          days: {}
        };

        week.days.forEach((day, dayIndex) => {
          const dayName = `Day ${day.dayNumber}`;
          processedWeeks[weekName].days[dayName] = {
            name: dayName,
            description: day.description || "",
            activities: Array.isArray(day.activities) ? day.activities : []
          };
        });
      });

      // Add weeks data in the format expected by the backend
      formData.append("weeks", JSON.stringify(processedWeeks));

      // Add image if exists
      if (programImage) {
        formData.append("image", programImage);
      }

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/programs`,
        formData,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 201) {
        // Reset form
        setProgramName("");
        setProgramDescription("");
        setShortDescription("");
        setProgramImage(null);
        setProgramLevelId("");
        setWeeks([]);
        setIsFree(false);
        setIsPublished(false);

        // Refresh programs list
        await fetchPrograms();

        // Show success message
        setMsg("Program created successfully!");
      }
    } catch (error) {
      console.error("Error creating program:", error);
      setError(error.response?.data?.message || "Failed to create program");
    }
  };

  const handleEdit = (program) => {
    // Fetch the full program data with weeks and days
    const fetchProgramDetails = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/programs/${program.id}`,
                { withCredentials: true }
            );
            setSelectedProgram(program);
            console.log(program, "SELECTED PROGRAM DATA");
            setEditModalOpen(true);
        } catch (error) {
            console.error('Error fetching program details:', error);
            setError('Failed to load program details');
        }
    };
    
    fetchProgramDetails();
  };

  const handleSaveEdit = async (editData) => {
    console.log(editData, "HANDLE SAVE EDIT");
    try {
      const formData = new FormData();
      formData.append('name', editData.name);
      formData.append('description', editData.description);
      formData.append('short_description', editData.shortDescription);
      formData.append('levelId', editData.levelId);
      formData.append('isFree', editData.isFree ? 1 : 0);
      formData.append('isPublished', editData.isPublished ? 1 : 0);
      
      if (editData.image) {
        formData.append('image', editData.image);
      }

      if (editData.imageUrl) {
        formData.append('imageUrl', editData.imageUrl);
      }
      // Add weeks and days data
      formData.append('weeks', JSON.stringify(editData.weeks));

        const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/programs/${selectedProgram.id}`,
          formData,
          {
            withCredentials: true,
            headers: {
            'Content-Type': 'multipart/form-data',
            },
          }
        );

        if (response.status === 200) {
        setEditModalOpen(false);
        setSelectedProgram(null);
        // Fetch initial data to update both programs and levels
        await fetchInitialData();
        setMsg("Program updated successfully");
        }
      } catch (error) {
      console.error('Error updating program:', error);
      setError(error.response?.data?.message || 'Failed to update program');
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/api/programs/${id}`,
        {
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        setDeleteConfirm(null);
        await fetchPrograms();
      }
    } catch (error) {
      console.error("Error deleting program:", error);
    }
  };

  const handleEditKeyPress = async (e, id) => {
    if (e.key === "Enter") {
      e.preventDefault();
      await handleEdit(id);
    } else if (e.key === "Escape") {
      setEditingId(null);
      setEditName("");
    }
  };

  const addWeek = () => {
    setWeeks((prevWeeks) => [
      ...prevWeeks,
      {
        weekNumber: prevWeeks.length + 1,
        days: [],
      },
    ]);
  };

  const removeWeek = (weekIndex) => {
    const updatedWeeks = weeks.filter((_, index) => index !== weekIndex);
    // Update week numbers
    updatedWeeks.forEach((week, index) => {
      week.weekNumber = index + 1;
      week.days.forEach((day) => {
        day.weekNumber = index + 1;
      });
    });
    setWeeks(updatedWeeks);
  };

  const removeDay = (weekIndex, dayIndex) => {
    const updatedWeeks = [...weeks];
    updatedWeeks[weekIndex].days = updatedWeeks[weekIndex].days.filter(
      (_, index) => index !== dayIndex
    );
    // Update day numbers
    updatedWeeks[weekIndex].days.forEach((day, index) => {
      day.dayNumber = index + 1;
    });
    setWeeks(updatedWeeks);
  };

  const addDay = (weekIndex) => {
    const updatedWeeks = [...weeks];
    const currentWeek = updatedWeeks[weekIndex];
    currentWeek.days.push({
      dayNumber: currentWeek.days.length + 1,
      weekNumber: currentWeek.weekNumber,
      description: "",
      activities: [],
      searchTerm: "",
    });
    setWeeks(updatedWeeks);
  };

  const handleWeekDescriptionChange = (weekIndex, description) => {
    const updatedWeeks = [...weeks];
    updatedWeeks[weekIndex].description = description;
    setWeeks(updatedWeeks);
  };

  const handleDayDescriptionChange = (weekIndex, dayIndex, description) => {
    const updatedWeeks = [...weeks];
    updatedWeeks[weekIndex].days[dayIndex].description = description;
    setWeeks(updatedWeeks);
  };

  const addActivityToDay = (weekIndex, dayIndex, activity) => {
    console.log("Adding activity:", activity);
    const updatedWeeks = [...weeks];
    const currentDay = updatedWeeks[weekIndex].days[dayIndex];

    if (!currentDay.activities) {
      currentDay.activities = [];
    }

    // Handle both possible ID field names and ensure we have a valid ID
    const activityId = activity.idactivity || activity.idactivities || activity.id;
    if (!activityId) {
      console.error("No valid activity ID found:", activity);
      return;
    }

    // Create a new activity object with consistent structure
    const newActivity = {
      idactivity: activityId,
        name: activity.name,
      description: activity.description || "",
        instanceId: Date.now(),
    };

    currentDay.activities.push(newActivity);
    setWeeks(updatedWeeks);
  };

  const removeActivityFromDay = (weekIndex, dayIndex, instanceId) => {
    const updatedWeeks = [...weeks];
    const currentDay = updatedWeeks[weekIndex].days[dayIndex];

    if (currentDay.activities) {
      currentDay.activities = currentDay.activities.filter(
        (a) => a.instanceId !== instanceId
      );
      setWeeks(updatedWeeks);
    }
  };

  const handleSearchKeyDown = (e, weekIndex, dayIndex) => {
    if (e.key === "Escape") {
      const updatedWeeks = [...weeks];
      updatedWeeks[weekIndex].days[dayIndex].searchTerm = "";
      setWeeks(updatedWeeks);
    }
  };

  const toggleWeek = (weekIndex) => {
    setExpandedWeeks((prev) => {
      if (prev.includes(weekIndex)) {
        return prev.filter((index) => index !== weekIndex);
      } else {
        return [...prev, weekIndex];
      }
    });
  };

  const toggleProgramWeek = (programId, weekName) => {
    setExpandedProgramWeeks(prev => ({
      ...prev,
      [`${programId}-${weekName}`]: !prev[`${programId}-${weekName}`]
    }));
  };

  const toggleProgramDay = (programId, weekName, dayName) => {
    setExpandedProgramDays(prev => ({
      ...prev,
      [`${programId}-${weekName}-${dayName}`]: !prev[`${programId}-${weekName}-${dayName}`]
    }));
  };

  // First, let's organize the data when we receive it
  const organizeProgram = (program) => {
    const organized = {
      idprograms: program.id,
      name: program.name,
      description: program.description,
      image_url: program.image_url,
      weeks: {},
    };

    // Group by week, then by day, then activities
    if (program.activities) {
      program.activities.forEach((activity) => {
        const weekName = activity.week_name;
        const dayName = activity.day_name;

        if (!organized.weeks[weekName]) {
          organized.weeks[weekName] = {};
        }
        if (!organized.weeks[weekName][dayName]) {
          organized.weeks[weekName][dayName] = [];
        }
        organized.weeks[weekName][dayName].push({
          name: activity.name,
          description: activity.description,
        });
      });
    }

    return organized;
  };

  const ImageModal = ({ imageUrl, onClose }) => {
    if (!imageUrl) return null;

    return (
      <div className="image-modal-overlay" onClick={onClose}>
        <div
          className="image-modal-content"
          onClick={(e) => e.stopPropagation()}
        >
          <img src={imageUrl} alt="Program" />
          <button className="close-button" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
      </div>
    );
  };

  const ProgramList = ({ programs }) => {
    return (
      <div className="programs-list">
        <h2>Existing Programs</h2>
        {msg && <div className="success-message">{msg}</div>}
            {error && <div className="error-message">{error}</div>}

        <div className="list-container">
          {programs.length > 0 ? (
            programs.map((program) => (
              <div key={program.id} className="list-item">
                {editingId === program.id ? (
                  // Edit mode
                  <div className="edit-form">
                    <input
                      type="text"
                      value={editName}
                      onChange={(e) => setEditName(e.target.value)}
                      className="edit-input"
                      placeholder="Program name"
                    />
                    <textarea
                      value={editDescription}
                      onChange={(e) => setEditDescription(e.target.value)}
                      className="edit-textarea"
                      placeholder="Program description"
                    />
                    <input
                      type="file"
                      onChange={(e) => setEditImage(e.target.files[0])}
                      className="edit-file-input"
                      accept="image/*"
                    />
                    <div className="edit-actions">
                      <button
                        onClick={() => handleEdit(program.id)}
                        className="save-button"
                      >
                        Save
                      </button>
                      <button
                        onClick={() => setEditingId(null)}
                        className="cancel-button"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="program-header">
                      <h3>{program.name}</h3>
                      <div className="program-actions">
                        <button
                          className="edit-button"
                          onClick={() => {
                            console.log("PROGRAM", program);
                            handleEdit(program);
                          }}
                        >
                          <i className="fas fa-pencil-alt"></i>
                        </button>
                        <button
                          className="delete-button"
                          onClick={() => {
                            setDeleteConfirm(program);
                          }}
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </div>
                    </div>

                    {program.description && (
                      <p className="program-description">
                        {program.description}
                      </p>
                    )}
                       {program.short_description && (
                      <p className="program-description">
                        {program.short_description} -  Nivå {program.level}
                      </p>
                    )}

                    {program.image_url && (
                      <div className="program-image-container">
                        <img
                          src={program.image_url}
                          alt={program.name}
                          className="program-thumbnail"
                          onClick={() => {
                            setSelectedImage(program.image_url);
                            setShowImageModal(true);
                          }}
                        />
                      </div>
                    )}

                    <div className="program-content">
                      {Object.entries(program.weeks || {}).map(([weekName, weekData]) => (
                          <div key={weekName} className="week-section">
                          <div 
                            className="week-header" 
                            onClick={(e) => {
                              // Don't toggle if clicking inside activity-selector
                              if (!e.target.closest('.activity-selector')) {
                                toggleProgramWeek(program.id, weekName);
                              }
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            <h4 className="week-title">
                              <i className={`fas fa-chevron-${expandedProgramWeeks[`${program.id}-${weekName}`] ? 'down' : 'right'}`} style={{ marginRight: '10px' }} />
                              {weekData.name}
                            </h4>
                          </div>
                          
                          {weekData.description && (
                            <p className="week-description-text">
                              {weekData.description}
                            </p>
                          )}
                          
                          {program.isFree === 1 && (
                            <span className="program-free-badge">Free</span>
                          )}
                          
                          {expandedProgramWeeks[`${program.id}-${weekName}`] && (
                            <div className="days-grid">
                              {Object.entries(weekData.days || {}).map(([dayNumber, dayData]) => (
                                  <div key={dayNumber} className="day-card">
                                  <div 
                                    className="day-header" 
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleProgramDay(program.id, weekName, dayNumber);
                                    }}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    <h5 className="day-title">
                                      <i className={`fas fa-chevron-${expandedProgramDays[`${program.id}-${weekName}-${dayNumber}`] ? 'down' : 'right'}`} style={{ marginRight: '10px' }} />
                                      {dayData.name}
                                    </h5>
                                  </div>
                                  
                                  {dayData.description && (
                                    <p className="day-description-text">
                                      {dayData.description}
                                    </p>
                                  )}
                                  
                                  {expandedProgramDays[`${program.id}-${weekName}-${dayNumber}`] && (
                                    <div className="activities-list programs-list">
                                      {dayData.activities.length > 0 ? (
                                        dayData.activities.map((activity, index) => (
                                          <div key={index} className="activity-card">
                                            <span className="activity-name" id={activity.idactivity}>
                                                {activity.name}
                                            </span>
                                              <span className="activity-description">
                                                {activity.description}
                                              </span>
                                            </div>
                                        ))
                                      ) : (
                                        <p className="no-activities">No activities scheduled</p>
                                      )}
                                    </div>
                              )}
                            </div>
                              ))}
                          </div>
                      )}
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            ))
          ) : (
            <div className="no-programs">No programs available</div>
          )}
        </div>
        {showImageModal && (
          <ImageModal
            imageUrl={selectedImage}
            onClose={() => {
              setShowImageModal(false);
              setSelectedImage(null);
            }}
          />
        )}
      </div>
    );
  };



  return (
    <div className="new-program-container">
      <div className="page-container">
        <div className="page-header-stack">
          <Link to="/dashboard" className="back-button">
            <i className="fas fa-arrow-left"></i> Back to Dashboard
          </Link>
          <h1>Create New Program</h1>
        </div>
        <form className="form-container" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="programName">Program Name</label>
            <input
              type="text"
              id="programName"
              name="programName"
              value={programName}
              onChange={(e) => setProgramName(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="shortDescription">Short Description</label>
            <input
              type="text"
              id="shortDescription"
              name="shortDescription"
              value={shortDescription}
              onChange={(e) => setShortDescription(e.target.value)}
              maxLength="255"
            />
          </div>
          <div className="form-group">
            <label htmlFor="programDescription">Description</label>
            <textarea
              id="programDescription"
              name="programDescription"
              value={programDescription}
              onChange={(e) => setProgramDescription(e.target.value)}
              rows="4"
            />
          </div>
          <div className="form-group">
            <label htmlFor="programImage">Program Image</label>
            <input
              type="file"
              id="programImage"
              name="programImage"
              accept="image/*"
              onChange={(e) => setProgramImage(e.target.files[0])}
            />
          </div>
          <div className="form-group">
            <label htmlFor="levelId">Intensity Level</label>
            <select
              id="levelId"
              name="levelId"
              value={programLevelId}
              onChange={(e) => setProgramLevelId(e.target.value)}
              className="form-select"
            >
              <option value="">Select a level</option>
              {levels.map((level) => (
                <option
                  key={level.idintensity_zone}
                  value={level.idintensity_zone}
                  style={{
                    backgroundColor: level.fargekode_bakgrunn,
                    color: level.fargekode_tekst,
                  }}
                >
                  {level.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label className="toggle-label">
              <span>Free Program</span>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={isFree}
                  onChange={(e) => setIsFree(e.target.checked)}
                />
                <span className="toggle-slider"></span>
              </div>
              <span className="toggle-text">{isFree ? 'Free' : 'Premium'}</span>
            </label>
          </div>
          <div className="form-group">
            <label className="toggle-label">
              <span>Publish Status</span>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={isPublished}
                  onChange={(e) => setIsPublished(e.target.checked)}
                />
                <span className="toggle-slider"></span>
              </div>
              <span className="toggle-text">{isPublished ? 'Published' : 'Draft'}</span>
            </label>
          </div>

          <div className="weeks-section" style={{ marginTop: "20px" }}>
            <h2>Program Weeks</h2>
            <button
              type="button"
              onClick={addWeek}
              style={{
                backgroundColor: "#28a745",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <i className="fas fa-plus"></i> Add Week
            </button>

            {weeks.map((week, weekIndex) => (
              <div
                key={weekIndex}
                className="week-container"
                style={{
                  border: "1px solid #ddd",
                  padding: "20px",
                  marginBottom: expandedWeeks.includes(weekIndex)
                    ? "15px"
                    : "0",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  // Don't toggle if clicking inside activity-selector
                  if (!e.target.closest('.activity-selector')) {
                    toggleWeek(weekIndex);
                  }
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <h3 style={{ margin: 0 }}>Week {week.weekNumber}</h3>
                  <div>
                    <button
                      type="button"
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: "8px",
                        color: "#666",
                      }}
                    >
                      <i
                        className={`fas fa-chevron-${
                          expandedWeeks.includes(weekIndex) ? "up" : "down"
                        }`}
                      ></i>
                    </button>
                    <button
                      type="button"
                      onClick={() => removeWeek(weekIndex)}
                      className="delete-button"
                      title="Delete week"
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </div>
                </div>

                {expandedWeeks.includes(weekIndex) && (
                  <>
                    <div
                      className="week-description"
                      style={{ marginBottom: "15px" }}
                    >
                      <input
                        type="text"
                        value={week.description || ""}
                        onChange={(e) =>
                          handleWeekDescriptionChange(weekIndex, e.target.value)
                        }
                        placeholder="Enter week description..."
                        onClick={(e) => e.stopPropagation()}
                        style={{
                          width: "100%",
                          padding: "8px",
                          borderRadius: "4px",
                          border: "1px solid #ddd",
                          marginTop: "10px",
                        }}
                      />
                    </div>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        addDay(weekIndex);
                      }}
                      style={{
                        backgroundColor: "#28a745",
                        color: "white",
                        padding: "8px 16px",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        marginBottom: "20px",
                        marginTop: "15px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        fontSize: "0.9em",
                      }}
                    >
                      <i className="fas fa-plus"></i> Add Day
                    </button>

                    {week.days.map((day, dayIndex) => (
                      <div
                        key={dayIndex}
                        className="day-container"
                        style={{
                          border: "1px solid #ddd",
                          padding: "15px",
                          marginBottom: "15px",
                          borderRadius: "4px",
                          backgroundColor: "white",
                        }}
                      >
                        <div className="day-header">
                          <h4 style={{ marginBottom: "15px" }}>
                            Day {day.dayNumber}
                          </h4>
                                     <button
                                                type="button"
                                                onClick={() => removeDay(weekIndex, dayIndex)}
                                                className="delete-button"
                                                title="Delete day"
                                            >
                                                <i className="fas fa-trash"></i>
                                            </button>
                        </div>

                        <div
                          className="day-description"
                          style={{ marginBottom: "15px" }}
                        >
                          <input
                            type="text"
                            value={day.description || ""}
                            onChange={(e) => {
                              e.stopPropagation();
                              handleDayDescriptionChange(
                                weekIndex,
                                dayIndex,
                                e.target.value
                              );
                            }}
                            onClick={(e) => e.stopPropagation()}
                            placeholder="Enter day description..."
                            style={{
                              width: "100%",
                              padding: "8px",
                              borderRadius: "4px",
                              border: "1px solid #ddd",
                              marginBottom: "10px",
                            }}
                          />
                        </div>

                        <ActivitySelector
                          dayNumber={day.dayNumber}
                          activities={activities}
                          selectedActivities={day.activities || []}
                          onActivityAdd={(activity) => addActivityToDay(weekIndex, dayIndex, activity)}
                          onActivityRemove={(instanceId) => removeActivityFromDay(weekIndex, dayIndex, instanceId)}
                          onSearchKeyDown={(e) => handleSearchKeyDown(e, weekIndex, dayIndex)}
                        />
                      </div>
                    ))}
                  </>
                )}
              </div>
            ))}
          </div>

          <button type="submit" className="submit-button">
            Create Program
          </button>
        </form>

        <ProgramList
          programs={programs}
          onEdit={handleEdit}
          onDelete={setDeleteConfirm}
        />

        {deleteConfirm && (
          <DeleteModal
            isOpen={!!deleteConfirm}
            onClose={() => setDeleteConfirm(null)}
            onConfirm={() => handleDelete(deleteConfirm.id)}
            itemName={`program "${deleteConfirm.name}"`}
          />
        )}

        {editModalOpen && selectedProgram && (
          <EditProgramModal
            program={selectedProgram}
            isOpen={editModalOpen}
            onClose={() => {
              setEditModalOpen(false);
              setSelectedProgram(null);
            }}
            onSave={handleSaveEdit}
            levels={levels}
            activities={activities}
          />
        )}
      </div>
    </div>
  );
}

